import { useState } from 'react';

function getDefaultTarget() {
  // Detect user's country from timezone (works regardless of browser language)
  // Only return countries we actually index listings for (PT, ES)
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (tz.startsWith('Europe/Lisbon') || tz.startsWith('Atlantic/Madeira') || tz.startsWith('Atlantic/Azores')) return 'PT';
    if (tz.startsWith('Europe/Madrid') || tz.startsWith('Atlantic/Canary')) return 'ES';
  } catch { /* Intl not available */ }

  // Fallback: browser language (only indexed target countries)
  const browserLang = (navigator.language || '').slice(0, 2).toLowerCase();
  const langToCountry = { pt: 'PT', es: 'ES' };
  return langToCountry[browserLang] || 'ES';
}

export function useArbitrageFilters() {
  const [sourceCountry, setSourceCountry] = useState('all');
  const [targetCountry, setTargetCountry] = useState(getDefaultTarget);
  const [minProfit, setMinProfit] = useState(0);
  const [filterMake, setFilterMake] = useState('all');
  const [filterModel, setFilterModel] = useState('all');
  const [filterVersion, setFilterVersion] = useState('all');
  const [filterFuelType, setFilterFuelType] = useState('all');
  const [minMileage, setMinMileage] = useState(0);
  const [maxMileage, setMaxMileage] = useState(300000);
  const [minYear, setMinYear] = useState(2017);
  const [maxYear, setMaxYear] = useState(2024);
  const [maxPrice, setMaxPrice] = useState(200000);
  const [sortBy, setSortBy] = useState('profit');
  const [sortDir, setSortDir] = useState('desc');
  const [qualityLevels, setQualityLevels] = useState([]); // [] = all, ['high'], ['low','medium'], etc.
  const [yearTolerance, setYearTolerance] = useState(1);       // ±1 year default
  const [mileageTolerance, setMileageTolerance] = useState(10000); // ±10,000km default

  const filterKey = `${filterMake}|${filterModel}|${filterVersion}|${filterFuelType}|${minMileage}|${maxMileage}|${minYear}|${maxYear}|${maxPrice}|${minProfit}|${sortBy}|${sortDir}|${sourceCountry}|${targetCountry}|${qualityLevels.join(',')}|${yearTolerance}|${mileageTolerance}`;

  return {
    sourceCountry, setSourceCountry,
    targetCountry, setTargetCountry,
    minProfit, setMinProfit,
    filterMake, setFilterMake,
    filterModel, setFilterModel,
    filterVersion, setFilterVersion,
    filterFuelType, setFilterFuelType,
    minMileage, setMinMileage,
    maxMileage, setMaxMileage,
    minYear, setMinYear,
    maxYear, setMaxYear,
    maxPrice, setMaxPrice,
    sortBy, setSortBy,
    sortDir, setSortDir,
    qualityLevels, setQualityLevels,
    yearTolerance, setYearTolerance,
    mileageTolerance, setMileageTolerance,
    filterKey,
  };
}
